<template>
  <div class="our-menu container">
       <div class="row">
        <masonry
        :cols="{default: 3, 1200: 2, 800: 1}"
        :gutter="30"
        >
        <div v-for="(item, index) in menu" :key="index" class="" data-aos="zoom-in">
            <div class="box">
              <h3 class="title mb-4">{{ item.carte_main_title }}</h3>
              <div v-for="(subitem, index) in item.carte_plats"  :key="index" class="item">
                <p class="name">{{ subitem.carte_nom_plat }}</p>
                <p  class="des" v-if="subitem.carte_des_plat">{{ subitem.carte_des_plat }}</p>
                <p class="divider">***</p>
               </div>
            </div>
        </div>
        </masonry>
      </div>
  </div>
</template>
<script>
import api from '@/api'
export default {
  data () {
    return {
      menu: null
    }
  },
  methods: {
    /**
     * Fetch menu data
     * @request HTTP | GET
     */
    fetchOurMenu () {
      this.axios.get(api.our_menu)
        .then(response => {
          this.menu = response.data[0].acf.notre_carte
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  mounted () {
    this.fetchOurMenu()
  }
}
</script>

<style lang="sass" scoped>
  @import 'OurMenu';
</style>



// WEBPACK FOOTER //
// src/components/OurMenu/OurMenu.vue